import http from "@/http-common";

class WarrantyClaimDataService {
  getUploadFileData(data: any): Promise<any> {
    return http.api.post("/getUploadFileData/",data);
  }
  convertCsvFile(FormData:FormData){
    return http.api.post("/convertCsvFile/",FormData,{responseType : "blob"});
  }
}
export default new WarrantyClaimDataService();
